import { Award, Users, BookOpen, Trophy, Target, Heart, Home } from 'lucide-react';
import './Strengths.css';

const Strengths = () => {
  return (
    <div className="str-main-wrapper">
   

        {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>STRENGTHS</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Strengths</li>
          </ul>
        </div>
      </section>

      {/* Content */}
      <div className="str-body-section">
        <div className="str-content-box">
          <p className="str-intro-para">
            Bihani Children's Academy stands out for its commitment to excellence in every aspect of education.
          </p>

          <div className="str-cards-grid">
            <div className="str-single-card">
              <div className="str-card-top">
                <div className="str-round-icon">
                  <Award className="str-svg-icon" size={28} />
                </div>
                <h3 className="str-card-heading">Academic Excellence</h3>
              </div>
              <p className="str-card-description">
                Our students consistently achieve outstanding results through dedicated teaching and comprehensive curriculum.
              </p>
            </div>

            <div className="str-single-card">
              <div className="str-card-top">
                <div className="str-round-icon">
                  <Users className="str-svg-icon" size={28} />
                </div>
                <h3 className="str-card-heading">Expert Faculty</h3>
              </div>
              <p className="str-card-description">
                Highly qualified and experienced teachers who are passionate about shaping young minds.
              </p>
            </div>

            <div className="str-single-card">
              <div className="str-card-top">
                <div className="str-round-icon">
                  <BookOpen className="str-svg-icon" size={28} />
                </div>
                <h3 className="str-card-heading">Strong Discipline</h3>
              </div>
              <p className="str-card-description">
                We instill values of discipline, respect, and responsibility that last a lifetime.
              </p>
            </div>

            <div className="str-single-card">
              <div className="str-card-top">
                <div className="str-round-icon">
                  <Heart className="str-svg-icon" size={28} />
                </div>
                <h3 className="str-card-heading">Caring Mentorship</h3>
              </div>
              <p className="str-card-description">
                Personal attention and guidance to help every student reach their full potential.
              </p>
            </div>

            <div className="str-single-card">
              <div className="str-card-top">
                <div className="str-round-icon">
                  <Trophy className="str-svg-icon" size={28} />
                </div>
                <h3 className="str-card-heading">Holistic Development</h3>
              </div>
              <p className="str-card-description">
                Focus on sports, arts, and extracurricular activities for all-round growth.
              </p>
            </div>

            <div className="str-single-card">
              <div className="str-card-top">
                <div className="str-round-icon">
                  <Target className="str-svg-icon" size={28} />
                </div>
                <h3 className="str-card-heading">Character Building</h3>
              </div>
              <p className="str-card-description">
                Emphasis on moral values and ethics to develop responsible citizens.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Strengths;